<template>
    <div class="explore-science">
        <Navbar :state="state" :subject="subject" >
            <template v-slot:navMsg v-if="stateData">
                <TempAvailabilityMessage :subject="subjectName" />
            </template>
        </Navbar>

        <section class="bg-light product-section" :style="{backgroundImage: 'url(' + backgroundImage + ')'}">
            <div class="py-4" :class="{'overlay': backgroundImage}">
                <div class="container" v-if="stateData && pagePublications.length">
                    <Product
                        :product="product"
                        :publications="pagePublications"
                        :state="state"
                        :grade="grade"
                        :subject="subject"
                        :language="language"
                        :can-swap-schools="false"
                    />
                </div>
            </div>
        </section>

        <BlockListViewer v-if="blocks" :blocks="blocks" :publications="pagePublications" />
        <Footer />
    </div>
</template>

<script>
import {mapGetters, mapState} from 'vuex'
import states from '@/common/states'
import Navbar from '@/components/Navbar'
import Product from '@/components/Product'
import Footer from '@/components/Footer'
import TempAvailabilityMessage from "@/components/TempAvailabilityMessage";
import BlockListViewer from "@/components/blocks/BlockListViewer";
import {applyFilter, getUniquePageProducts} from "@/common/publicationFilters";

export default {
    name: 'explore-science',
    data: () => ({
        states: states,
        pageId: 6, // Controls what blocks and publications are shown
        subjectName: 'science2',
        blocks: [],
    }),
    props: ['state', 'grade', 'subject', 'language'],
    computed: {
        ...mapState({
            pages: state => state.stateData.pages,
            statePublications: state => state.stateData.stateData.publications,
            stateData: state => state.stateData.stateData,
            selectedState: state => state.stateData.selectedState,
            selectedLanguage: state => state.stateData.selectedLanguage,
            publicationResources: state => state.stateData.publicationResources,
        }),
        ...mapGetters({
            pagePublications: 'getExploreSciencePublications',
        }),
        backgroundImage () {
            var backgroundImage = null
            if (this.stateData.product_bg) {
                if (
                    this.stateData.product_bg.startsWith('http://') ||
                    this.stateData.product_bg.startsWith('https://') ||
                    this.stateData.product_bg.startsWith('//')
                ) {
                    backgroundImage = this.stateData.product_bg
                } else {
                    backgroundImage = '//' + this.stateData.product_bg
                }
            }
            return backgroundImage
        },
        product () {
            let product = {}
            // console.log(this.socialStudiesPublications);

            _.filter(this.pagePublications, publication => {
                if (
                    publication.grade    == this.$route.params.grade &&
                    publication.language == this.$route.params.language
                ) {
                    product = publication
                }
            })
            return product
        },
        page() {
            return this.$store.getters.getPageById(this.pageId);
        },

    },
    created() {
        this.getPageBlocks();
        this.getPublicationResources();
    },
    watch: {
        selectedState: {
            handler(state) {
                if (!this.$route.params.state || this.$route.params.state !== state) {
                    this.pushRoute(this.subjectName, state, 0, 'en')
                    return;
                }
                this.getPageBlocks();
            }
        },
        '$route': {
            handler (route) {
                if (!route.params.state) {
                    this.pushRoute(this.subjectName, this.selectedState, 0, this.selectedLanguage)
                }
                if (!this.pagePublications.length && this.$route.params.language !== 'en') {
                    this.pushRoute(this.subjectName, this.selectedState, 0, 'en')
                }
            },
            deep: true,
            immediate: true
        }
    },
    components: {
        BlockListViewer,
        TempAvailabilityMessage,
        Navbar,
        Product,
        Footer,
    },
    methods: {
        getPublicationResources () {
            this.$store.dispatch('getPublicationResources', this.pageId)
        },
        getPageBlocks() {
            this.$store.dispatch('getPageBlocks', {pageId: this.pageId, state: this.selectedState})
                .then((data) => {
                    this.blocks = data;
                })
        },
        pushRoute(subject, state, grade = 0, language = 'en') {
            this.$router.push({
                name: subject,
                params: {
                    state: state,
                    grade: grade,
                    subject: subject,
                    language: language
                }
            })
        }
    },
}
</script>


<style lang="scss" scoped>
@import "@/assets/scss/_colors.scss";

.product-section {
    background-size: cover;
    background-repeat: no-repeat;
}

.product-section .overlay {
    height: 100%;
    background-color: rgba(0, 0, 0, .33);
}
</style>

